// extracted by mini-css-extract-plugin
module.exports = {"Pie":"Pie_Pie__Hs-hE","Chart":"Pie_Chart__2MhiX"};